module.exports = __webpack_public_path__ + "img/029-goat.b3ec002b.svg";